import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyProfileComponent } from './pages/my-profile/my-profile.component';
import { UserProfileRoutingModule } from './user-profile.routing.module';
import { UserProfileService } from './services/user-profile.service';
import { SharedStandAloneImports } from '../business-partners/model/prospect.model';
import { UpGeneralComponent } from './common/up-general/up-general.component';
import { UpRimsServiceComponent } from './common/up-rims-service/up-rims-service.component';
import { UpRimsSalesComponent } from './common/up-rims-sales/up-rims-sales.component';
import { DatePickerModule, DateRangePickerModule, DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NumericTextBoxModule, SignatureModule, UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { UserProfilePopupComponent } from './pages/user-profile-popup/user-profile-popup.component';
import { UsersComponent } from './pages/users/users.component';
import { SignaturePopupComponent } from './common/up-general/signature-popup/signature-popup.component';
import { AddressesGridPopupComponent } from './common/up-general/addresses-grid-popup/addresses-grid-popup.component';
import { UpPreferencesComponent } from './common/up-preferences/up-preferences.component';
import { AssignmentGridComponent } from './common/assignment-grid/assignment-grid.component';
import { Grid as InavistaGrid } from '@inavista/components/grid';
import { AdvancedEmployeeSearchPopupComponent } from './common/up-rims-service/advanced-employee-search-popup/advanced-employee-search-popup.component';
import { AdvancedIscCodesPopupComponent } from './common/up-rims-service/advanced-isc-codes-popup/advanced-isc-codes-popup.component';
import { DirectReportsComponent } from './pages/users/direct-reports/direct-reports.component';
import { RadioButtonModule } from '@syncfusion/ej2-angular-buttons';
import { ListViewModule } from '@syncfusion/ej2-angular-lists';
import { DropdownToggleDirective } from 'projects/shared/src/lib/directives/dropdown-toggle.directive';



@NgModule({
  declarations: [
    UsersComponent,
    MyProfileComponent,
    UserProfilePopupComponent,
    UpGeneralComponent,
    UpRimsSalesComponent,
    UpRimsServiceComponent,
    SignaturePopupComponent,
    AddressesGridPopupComponent,
    UpPreferencesComponent,
    AssignmentGridComponent,
    AdvancedEmployeeSearchPopupComponent,
    AdvancedIscCodesPopupComponent,
    DirectReportsComponent
  ],
  imports: [
    CommonModule,
    UserProfileRoutingModule,
    SharedStandAloneImports,
    DropdownToggleDirective,
    DatePickerModule,
    DateTimePickerModule,
    UploaderModule,
    SignatureModule,
    NumericTextBoxModule,
    RadioButtonModule,
    ListViewModule,
    InavistaGrid
  ],
  exports: [
    UsersComponent,
    MyProfileComponent,
    UserProfilePopupComponent
  ],
  providers: [
    UserProfileService
  ]
})
export class UserProfileModule { }
 